import React from 'react';
import styled from 'styled-components';
import {Chip} from '@mui/material';

const FriendChip = styled(Chip)`
	margin: 2px;
`

const FriendChips = styled.div`
	display: flex;
	margin: 2px;
	flex-wrap: wrap;
	flex-grow: 1;
`;

export default function Chips({list, handleDelete}) {
	return <FriendChips>
		{list.map((item, index) =>
			<FriendChip
				key={index}
				variant="outlined"
				color="primary"
				size="small"
				label={item}
				// avatar={<Avatar>{item[0].toUpperCase()}</Avatar>}
				onDelete={() => handleDelete(item)}
			/>
		)}
	</FriendChips>
}